/**
 * Drawer localization schema.
 * Defines all translation strings for the navigation drawer sections and items.
 *
 * @drawer_header @app_name Display name of the application in the drawer header.
 * @drawer_sections @section @title Section title displayed in the drawer (optional in rail mode).
 * @drawer_sections @section @drawer_items @title title Drawer item visible title.
 * @drawer_sections @section @drawer_items @tooltip_text Drawer item tooltip shown on hover.
 */
export default {
  // Drawer Header
  drawer_header: {
    app_name: "Lab Portal",
  },

  // Drawer Sections
  drawer_sections: {
    // Overview Section
    overview_section: {
      // Section Title
      title: "Општ преглед",

      // Overview Items
      drawer_items: {
        channels: {
          title: "Канали",
          tooltip_text: "Статус и управување со канали",
        },

        validation: {
          title: "Валидација",
          tooltip_text: "Валидација на резултати",
        },

        allVisits: {
          title: "Сите визити",
          tooltip_text: "Преглед на сите визити на пациенти",
        },

        newResults: {
          title: "Нови резултати",
          tooltip_text: "Неодамна примени резултати",
        },

        search: {
          title: "Пребарување",
          tooltip_text: "Пребарување на пациенти и примероци",
        },

        starred: {
          title: "Обележани",
          tooltip_text: "Обележани ставки",
        },

        results: {
          title: "Резултати",
          tooltip_text: "Лабораториски резултати",
        },

        balance: {
          title: "Биланс",
          tooltip_text: "Биланс на плаќања",
        },
      },
    },

    // About Section
    about_section: {
      // About Items
      drawer_items: {
        about: {
          title: "За апликацијата",
          tooltip_text: "Информации за оваа апликација",
        },
      },
    },

    // Dev Section (only visible when LAB_PORTAL_FE_DEV=true)
    dev_section: {
      title: "Развивач",
      drawer_items: {
        uiStates: {
          title: "UI состојби",
          tooltip_text: "Каталог на UI состојби",
        },
      },
    },
  },
};
